export default "__VITE_ASSET__hXwv0Yss__"